import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Experiment } from '@mc/experiments-react'
import { useStaticData } from '@mc/static-data-react'
import { EMAIL_CAPTURE_IN_PROMO_MODAL_FLAG_NAME } from '../constants'
import { EmailCaptureContent } from './EmailCaptureContent'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

export const EmailCaptureInPromoModalExp = ({
  control,
}: {
  control: React.ReactNode
}) => {
  const { isLoggedIn } = useStaticData<{
    isLoggedIn?: boolean
  }>()

  if (isLoggedIn) return control

  return (
    <Experiment
      name={EMAIL_CAPTURE_IN_PROMO_MODAL_FLAG_NAME}
      control={() => control}
      variant_1={() => (
        <QueryClientProvider client={queryClient}>
          <EmailCaptureContent />
        </QueryClientProvider>
      )}
    />
  )
}
